var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { State, Action, Selector, Store } from '@ngxs/store';
import { AuthStateModel } from './auth.state.model';
import { LoginWithBiodigital, LoginSuccess, LoginFailure, GetUserProfile, Logout, LogoutSuccess, IsLoggedIn, IsLoggedInSuccess, IsLoggedInFailure, GetUserProfileSuccess, GetUserProfileFailure, CheckSession, CheckProfile, CheckProfileSuccess, CheckProfileFailure, GetEnvironmentSettings, GetEnvironmentSettingsSuccess, GetEnvironmentSettingsFailure, ResetPassword, ResetPasswordSuccess, ResetPasswordFailure, SignUp, SignUpSuccess, SignUpFailure, LoginWithGoogle, LoginWithFacebook, SetUserLocale, SetUserLocaleSuccess, CheckLocale, GetUserApps, SetSelectedUserApp, SetUserApps, CheckSelectedUserApp, SetUserMessageViewed, SetUserMessageViewedSuccess, SetUserMessageViewedFail, ResetAuth, GetUserMessage, GetUserMessageFail, GetUserMessageSuccess, LogoutFailure } from './auth.actions';
import { AuthService } from '../../auth.service';
import { SetOrganizations, ResetOrganizations } from 'src/app/organizations/state/organizations.actions';
import { finalize } from 'rxjs/operators';
import { StorageService, StorageItemEnum } from 'src/app/shared/storage.service';
import { locales, defaultLocale } from 'src/app/locale-config.module';
import { ResetBookmarks } from 'src/app/bookmarks/state/bookmarks.actions';
import { ResetEditPage } from 'src/app/edit/state/edit.actions';
import { ResetEnginePosition } from 'src/app/engine/state/engine.actions';
import { ResetExplore } from 'src/app/explore/state/explore.actions';
import { ResetHistory } from 'src/app/history/state/history.actions';
import { ResetLabels } from 'src/app/story/state/labels/story.labels.actions';
import { ResetStory } from 'src/app/story/state/story.actions';
import { ResetStoryChapters } from 'src/app/story/state/chapters/story.chapters.actions';
import { ResetView } from 'src/app/view/state/view.actions';
import { ResetLayout } from 'src/app/layout/state/layout.actions';
import { ResetEngineNodes } from 'src/app/engine/state/nodes/engine.nodes.actions';
import * as _ from 'lodash';
import { UserMessageService } from 'src/app/shared/user-message.service';
import { ErrorService, ErrorMessage } from 'src/app/shared/error.service';
var initialState = {
    loading: false,
    loggedIn: null,
    userLocale: null
};
var AuthState = /** @class */ (function () {
    function AuthState(authService, userMessageService, storageService, localeId, store, errorService) {
        this.authService = authService;
        this.userMessageService = userMessageService;
        this.storageService = storageService;
        this.localeId = localeId;
        this.store = store;
        this.errorService = errorService;
    }
    /**
     * Selectors
     */
    AuthState.getLoggedIn = function (state) {
        return state.loggedIn;
    };
    AuthState.getEnvironmentSettings = function (state) {
        return state.environmentSettings;
    };
    AuthState.getUserProfile = function (state) {
        return state.userProfile;
    };
    AuthState.getProfileCheck = function (state) {
        return state.profileCheck;
    };
    AuthState.getLoading = function (state) {
        return state.loading;
    };
    AuthState.getUserLocale = function (state) {
        return state.userLocale;
    };
    AuthState.getUserLanguage = function (state) {
        return _.get(state, 'userLocale.lang', defaultLocale.lang);
    };
    AuthState.getUserApps = function (state) {
        return _.get(state, 'userApps', []);
    };
    AuthState.getSelectedUserApp = function (state) {
        var apps = state.userApps || [];
        return apps.find(function (app) { return app.id === state.selectedAppId; });
    };
    AuthState.isPremiumUser = function (state) {
        return _.get(state, 'userProfile.premium_account_valid') === true;
    };
    /**
     * Actions
     */
    AuthState.prototype.isLoggedIn = function (context, action) {
        context.patchState({ loading: true });
        this.authService.isLoggedIn()
            .pipe(finalize(function () { return context.patchState({ loading: false }); }))
            .subscribe(function (result) {
            if (result.signed_in) {
                context.dispatch(new IsLoggedInSuccess());
            }
            else {
                context.dispatch(new IsLoggedInFailure());
            }
        });
    };
    AuthState.prototype.isLoggedInSuccess = function (context, action) {
        context.patchState({
            loggedIn: true
        });
    };
    AuthState.prototype.isLoggedInFailure = function (context, action) {
        context.patchState({
            loggedIn: false
        });
    };
    AuthState.prototype.login = function (context, action) {
        var _this = this;
        context.patchState({ loading: true });
        this.authService.loginWithBiodigital(action.login)
            .pipe(finalize(function () { return context.patchState({ loading: false }); }))
            .subscribe(function () {
            context.dispatch(new LoginSuccess());
        }, function (error) {
            _this.logFailure('LOGIN_FAILURE', error);
            context.dispatch(new LoginFailure(error, action.login));
        });
    };
    AuthState.prototype.loginWithGoogle = function (context, action) {
        var _this = this;
        context.patchState({ loading: true });
        this.authService.loginWithGoogle(action.login)
            .pipe(finalize(function () { return context.patchState({ loading: false }); }))
            .subscribe(function () {
            context.dispatch(new LoginSuccess());
        }, function (error) {
            if (action.login.groupCodeMode === 1 || action.login.groupInviteMode === 1) {
                _this.logFailure('GOOGLE_SIGNUP_FAILURE', error);
            }
            context.dispatch(new LoginFailure(error, action.login));
        });
    };
    // Deprecated
    AuthState.prototype.loginWithFacebook = function (context, action) {
        context.patchState({ loading: true });
        this.authService.loginWithFacebook(action.login)
            .pipe(finalize(function () { return context.patchState({ loading: false }); }))
            .subscribe(function () {
            context.dispatch(new LoginSuccess());
        }, function (error) {
            context.dispatch(new LoginFailure(error, action.login));
        });
    };
    AuthState.prototype.loginSuccess = function (context, action) {
        context.dispatch(new IsLoggedIn());
        context.dispatch(new CheckLocale());
    };
    AuthState.prototype.logout = function (context, action) {
        context.patchState({ loading: true });
        this.authService.logout()
            .pipe(finalize(function () { return context.patchState({ loading: false }); }))
            .subscribe(function () { return context.dispatch(new LogoutSuccess()); }, function () { return context.dispatch(new LogoutFailure()); });
    };
    AuthState.prototype.logoutSuccess = function (context, action) {
        context.setState(initialState);
        context.dispatch(new ResetAuth());
        context.dispatch(new ResetBookmarks());
        context.dispatch(new ResetEditPage());
        context.dispatch(new ResetEnginePosition());
        context.dispatch(new ResetEngineNodes());
        context.dispatch(new ResetExplore());
        context.dispatch(new ResetHistory());
        context.dispatch(new ResetLabels());
        context.dispatch(new ResetLayout());
        context.dispatch(new ResetOrganizations());
        context.dispatch(new ResetStory());
        context.dispatch(new ResetStoryChapters());
        context.dispatch(new ResetView());
        // clear cached storage
        this.storageService.clearSessionStorage();
    };
    AuthState.prototype.checkProfile = function (context, action) {
        context.patchState({ loading: true });
        return this.authService.checkProfile(action.email)
            .pipe(finalize(function () { return context.patchState({ loading: false }); }))
            .subscribe(function (profile) {
            context.dispatch(new CheckProfileSuccess(profile));
        }, function (error) {
            context.dispatch(new CheckProfileFailure(error));
        });
    };
    AuthState.prototype.checkProfileSuccess = function (context, action) {
        context.patchState({
            profileCheck: action.profile
        });
    };
    AuthState.prototype.getUserProfile = function (context, action) {
        context.patchState({ loading: true });
        return this.authService.getUserProfile()
            .pipe(finalize(function () { return context.patchState({ loading: false }); }))
            .subscribe(function (userProfile) {
            context.dispatch(new GetUserProfileSuccess(userProfile));
        }, function (error) {
            context.dispatch(new GetUserProfileFailure(error));
        });
    };
    AuthState.prototype.getUserProfileSuccess = function (context, action) {
        context.patchState({
            userProfile: action.userProfile
        });
        context.dispatch(new SetOrganizations(action.userProfile.organizations));
        context.dispatch(new GetUserApps());
        context.dispatch(new CheckLocale());
    };
    AuthState.prototype.getUserApps = function (context, action) {
        this.authService.getUserApps()
            .subscribe(function (apps) {
            context.dispatch(new SetUserApps(apps));
            context.dispatch(new CheckSelectedUserApp());
        }, 
        // #TODO: handle errors
        function (err) {
        });
    };
    AuthState.prototype.setUserApps = function (context, _a) {
        var apps = _a.apps;
        context.patchState({
            userApps: apps
        });
    };
    AuthState.prototype.setSelectedUserApp = function (context, _a) {
        var appId = _a.appId;
        context.patchState({
            selectedAppId: appId
        });
        // update storage
        if (appId !== null) {
            this.storageService.setLocalItem(StorageItemEnum.UserAppId, appId);
        }
        else {
            this.storageService.removeLocalItem(StorageItemEnum.UserAppId);
        }
    };
    AuthState.prototype.checkSelectedUserApp = function (context, action) {
        var apps = context.getState().userApps;
        var storedAppId = this.storageService.getLocalItem(StorageItemEnum.UserAppId);
        if (storedAppId) { // set stored app
            var appId = parseInt(storedAppId, 10);
            context.dispatch(new SetSelectedUserApp(appId));
        }
        else if (apps && apps.length) { // set default app
            context.dispatch(new SetSelectedUserApp(apps[0].id));
        }
    };
    AuthState.prototype.checkSession = function (context, action) {
        context.patchState({ loading: true });
        this.authService.isLoggedIn()
            .pipe(finalize(function () { return context.patchState({ loading: false }); }))
            .subscribe(function (result) {
            if (result.signed_in) {
                context.dispatch(new IsLoggedInSuccess());
                context.dispatch(new GetUserProfile());
            }
            else {
                context.dispatch(new IsLoggedInFailure());
            }
        });
    };
    AuthState.prototype.getEnvironmentSettings = function (context, action) {
        context.patchState({ loading: true });
        return this.authService.getEnvironmentSettings()
            .pipe(finalize(function () { return context.patchState({ loading: false }); }))
            .subscribe(function (environmentSettings) {
            context.dispatch(new GetEnvironmentSettingsSuccess(environmentSettings));
        }, function (error) {
            context.dispatch(new GetEnvironmentSettingsFailure(error));
        });
    };
    AuthState.prototype.GetEnvironmentSettingsSuccess = function (context, action) {
        context.patchState({
            environmentSettings: action.environmentSettings
        });
    };
    AuthState.prototype.resetPassword = function (context, action) {
        context.patchState({ loading: true });
        this.authService.resetPassword(action.email)
            .pipe(finalize(function () { return context.patchState({ loading: false }); }))
            .subscribe(function () {
            context.dispatch(new ResetPasswordSuccess(action.email));
        }, function (error) {
            context.dispatch(new ResetPasswordFailure(error));
        });
    };
    AuthState.prototype.signUp = function (context, action) {
        context.patchState({ loading: true });
        return this.authService.signUp(action.value)
            .pipe(finalize(function () { return context.patchState({ loading: false }); }))
            .subscribe(function () {
            context.dispatch(new SignUpSuccess());
        }, function (error) {
            context.dispatch(new SignUpFailure(error));
        });
    };
    AuthState.prototype.signUpFailure = function (context, action) {
        this.logFailure('BIODIGITAL_SIGNUP_FAILURE', action);
    };
    AuthState.prototype.setUserLocale = function (context, _a) {
        var locale = _a.locale;
        // set storage
        this.storageService.setLocalItem(StorageItemEnum.Locale, locale.id);
        context.patchState({ userLocale: locale });
        context.dispatch(new SetUserLocaleSuccess(locale));
    };
    AuthState.prototype.checkLocale = function (context, action) {
        var _this = this;
        var targetLocale = locales.find(function (locale) { return locale.id === _this.localeId; }) || defaultLocale;
        context.dispatch(new SetUserLocale(targetLocale));
    };
    AuthState.prototype.getUserMessage = function (context, _a) {
        var type = _a.type, mode = _a.mode;
        this.userMessageService.getUserMessage(type, mode)
            .subscribe(function (message) {
            context.dispatch(new GetUserMessageSuccess(message));
        }, function () {
            context.dispatch(new GetUserMessageFail(type));
        });
    };
    AuthState.prototype.setUserMessageViewed = function (context, _a) {
        var messageSeenId = _a.messageSeenId;
        this.userMessageService.setUserMessageViewed(messageSeenId)
            .subscribe(function () { return context.dispatch(new SetUserMessageViewedSuccess()); }, function () { return context.dispatch(new SetUserMessageViewedFail()); });
    };
    AuthState.prototype.resetAuth = function (context, action) {
        context.setState(initialState);
    };
    AuthState.prototype.logFailure = function (category, error) {
        var message = _.get(error, 'message') || '';
        var log = _.get(error, 'error.error.message') || '';
        this.errorService.logError(new ErrorMessage(category, message, log)).subscribe();
    };
    AuthState.prototype.ngxsOnInit = function (context) {
        context.dispatch(new CheckSession());
        context.dispatch(new CheckLocale());
        context.dispatch(new CheckSelectedUserApp());
    };
    __decorate([
        Action(IsLoggedIn),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, IsLoggedIn]),
        __metadata("design:returntype", void 0)
    ], AuthState.prototype, "isLoggedIn", null);
    __decorate([
        Action(IsLoggedInSuccess),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, IsLoggedInSuccess]),
        __metadata("design:returntype", void 0)
    ], AuthState.prototype, "isLoggedInSuccess", null);
    __decorate([
        Action(IsLoggedInFailure),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, IsLoggedInFailure]),
        __metadata("design:returntype", void 0)
    ], AuthState.prototype, "isLoggedInFailure", null);
    __decorate([
        Action(LoginWithBiodigital),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, LoginWithBiodigital]),
        __metadata("design:returntype", void 0)
    ], AuthState.prototype, "login", null);
    __decorate([
        Action(LoginWithGoogle),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, LoginWithGoogle]),
        __metadata("design:returntype", void 0)
    ], AuthState.prototype, "loginWithGoogle", null);
    __decorate([
        Action(LoginWithFacebook),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, LoginWithFacebook]),
        __metadata("design:returntype", void 0)
    ], AuthState.prototype, "loginWithFacebook", null);
    __decorate([
        Action(LoginSuccess),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, LoginSuccess]),
        __metadata("design:returntype", void 0)
    ], AuthState.prototype, "loginSuccess", null);
    __decorate([
        Action(Logout),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Logout]),
        __metadata("design:returntype", void 0)
    ], AuthState.prototype, "logout", null);
    __decorate([
        Action(LogoutSuccess),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, LogoutSuccess]),
        __metadata("design:returntype", void 0)
    ], AuthState.prototype, "logoutSuccess", null);
    __decorate([
        Action(CheckProfile),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, CheckProfile]),
        __metadata("design:returntype", void 0)
    ], AuthState.prototype, "checkProfile", null);
    __decorate([
        Action(CheckProfileSuccess),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, CheckProfileSuccess]),
        __metadata("design:returntype", void 0)
    ], AuthState.prototype, "checkProfileSuccess", null);
    __decorate([
        Action(GetUserProfile),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, GetUserProfile]),
        __metadata("design:returntype", void 0)
    ], AuthState.prototype, "getUserProfile", null);
    __decorate([
        Action(GetUserProfileSuccess),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, GetUserProfileSuccess]),
        __metadata("design:returntype", void 0)
    ], AuthState.prototype, "getUserProfileSuccess", null);
    __decorate([
        Action(GetUserApps),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, GetUserApps]),
        __metadata("design:returntype", void 0)
    ], AuthState.prototype, "getUserApps", null);
    __decorate([
        Action(SetUserApps),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetUserApps]),
        __metadata("design:returntype", void 0)
    ], AuthState.prototype, "setUserApps", null);
    __decorate([
        Action(SetSelectedUserApp),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetSelectedUserApp]),
        __metadata("design:returntype", void 0)
    ], AuthState.prototype, "setSelectedUserApp", null);
    __decorate([
        Action(CheckSelectedUserApp),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, CheckSelectedUserApp]),
        __metadata("design:returntype", void 0)
    ], AuthState.prototype, "checkSelectedUserApp", null);
    __decorate([
        Action(CheckSession),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, CheckSession]),
        __metadata("design:returntype", void 0)
    ], AuthState.prototype, "checkSession", null);
    __decorate([
        Action(GetEnvironmentSettings),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, GetEnvironmentSettings]),
        __metadata("design:returntype", void 0)
    ], AuthState.prototype, "getEnvironmentSettings", null);
    __decorate([
        Action(GetEnvironmentSettingsSuccess),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, GetEnvironmentSettingsSuccess]),
        __metadata("design:returntype", void 0)
    ], AuthState.prototype, "GetEnvironmentSettingsSuccess", null);
    __decorate([
        Action(ResetPassword),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ResetPassword]),
        __metadata("design:returntype", void 0)
    ], AuthState.prototype, "resetPassword", null);
    __decorate([
        Action(SignUp),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SignUp]),
        __metadata("design:returntype", void 0)
    ], AuthState.prototype, "signUp", null);
    __decorate([
        Action(SignUpFailure),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SignUpFailure]),
        __metadata("design:returntype", void 0)
    ], AuthState.prototype, "signUpFailure", null);
    __decorate([
        Action(SetUserLocale),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetUserLocale]),
        __metadata("design:returntype", void 0)
    ], AuthState.prototype, "setUserLocale", null);
    __decorate([
        Action(CheckLocale),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, CheckLocale]),
        __metadata("design:returntype", void 0)
    ], AuthState.prototype, "checkLocale", null);
    __decorate([
        Action(GetUserMessage),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, GetUserMessage]),
        __metadata("design:returntype", void 0)
    ], AuthState.prototype, "getUserMessage", null);
    __decorate([
        Action(SetUserMessageViewed),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetUserMessageViewed]),
        __metadata("design:returntype", void 0)
    ], AuthState.prototype, "setUserMessageViewed", null);
    __decorate([
        Action(ResetAuth),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ResetAuth]),
        __metadata("design:returntype", void 0)
    ], AuthState.prototype, "resetAuth", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [AuthStateModel]),
        __metadata("design:returntype", void 0)
    ], AuthState, "getLoggedIn", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [AuthStateModel]),
        __metadata("design:returntype", void 0)
    ], AuthState, "getEnvironmentSettings", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [AuthStateModel]),
        __metadata("design:returntype", void 0)
    ], AuthState, "getUserProfile", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [AuthStateModel]),
        __metadata("design:returntype", void 0)
    ], AuthState, "getProfileCheck", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [AuthStateModel]),
        __metadata("design:returntype", void 0)
    ], AuthState, "getLoading", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [AuthStateModel]),
        __metadata("design:returntype", void 0)
    ], AuthState, "getUserLocale", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [AuthStateModel]),
        __metadata("design:returntype", void 0)
    ], AuthState, "getUserLanguage", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [AuthStateModel]),
        __metadata("design:returntype", void 0)
    ], AuthState, "getUserApps", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [AuthStateModel]),
        __metadata("design:returntype", void 0)
    ], AuthState, "getSelectedUserApp", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [AuthStateModel]),
        __metadata("design:returntype", void 0)
    ], AuthState, "isPremiumUser", null);
    AuthState = __decorate([
        State({
            name: 'auth',
            defaults: initialState
        }),
        __metadata("design:paramtypes", [AuthService,
            UserMessageService,
            StorageService, String, Store,
            ErrorService])
    ], AuthState);
    return AuthState;
}());
export { AuthState };
